import type SiteDowntimeType from './SiteDowntimeType'

export enum SiteDowntimeCategory {
  Derack = 'Derack',
}

interface SiteDowntimeOption {
  display: string
  key: number
  value: SiteDowntimeType
}

export default interface SiteDowntimeOptions {
  label: string
  options: Array<SiteDowntimeOption>
}
